export default __webpack_public_path__ + "static/media/image22.6c17b386.gif";